import React from 'react';
import AgVendLogo from 'assets/integrations/AgVend.png';
import Provider from 'screens/Integrations/SubmissionHistory/context/Provider';
import Instructions from 'screens/Integrations/components/Instructions';
import LandingPage from 'screens/Integrations/components/LandingPage';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import useIncomingInvoiceRetailers from 'hooks/useIncomingInvoiceRetailers';

export const STEPS = [
  {
    number: 1,
    header: 'Select Invoices',
    description:
      'Start a new import and select from your list of invoices across all available retailers'
  },
  {
    number: 2,
    header: 'Match Companies',
    description:
      'Match retailers from invoices to Companies in Cropwise Financials'
  },
  {
    number: 3,
    header: 'Match Products',
    description:
      'Confirm matches to the Crompwise Product List and choose selections for unrecognized products'
  },
  {
    number: 4,
    header: 'Match of Units of Measure',
    description:
      'Confirm product units of measure are correctly matched, and select a match for custom units'
  },
  {
    number: 5,
    header: 'Review and Import',
    description: 'Review the list of invoices you’ve selected to import'
  }
];

const AgVendLandingPage = () => {
  const { availableRetailers } = useIncomingInvoiceRetailers();

  return (
    <>
      <LandingPage
        headerText="Import Invoices via Retailer Portals"
        byText="Powered by"
        breadcrumbText="New Invoice Import"
        ownerText={INTEGRATIONS.agVend}
        targetPath={INTEGRATIONS.agVend}
        buttonText="Start a New Invoice Import"
      />
      <div className="w-full border-t-1 mb-5" />
      <div className="mb-10">
        <h1
          data-testid="available-reatailers-title"
          className="text-base text-neutral-600"
        >
          AVAILABLE RETAILERS
        </h1>
        <div
          id="available-reatailers"
          className="flex flex-row flex-wrap w-full"
        >
          {availableRetailers?.map(retailer => (
            <div
              key={retailer.id}
              className="flex justify-center items-center mt-4 mr-4 shadow-lg rounded-lg p-4 bg-white cursor-pointer transition-colors w-40 h-36"
            >
              <img
                src={`data:image/png;base64, ${retailer.thumb}`}
                alt={retailer.name}
                width={96}
                height={64}
                className="mr-3"
                data-testId="retailer-logo-base64"
              />
            </div>
          ))}
        </div>
      </div>
      <Provider integrationType={INTEGRATIONS.agVend} />
      <Instructions
        steps={STEPS}
        footerInstructions={null}
        headerInstructions="How to import your invoices"
      />
      <div className="w-2/3 ml-2 flex flex-row">
        <div className="bg-white rounded-xl shadow-md border p-7 mr-4 h-fit w-64 min-w-165px">
          <img
            src={AgVendLogo}
            alt=""
            style={{ width: '104px' }}
            data-testid="agvend-logo"
          />
        </div>
        <div className="mb-16">
          <p>
            AgVend is the leading provider of digital enablement solutions that
            transform the way agribusinesses operate and engage with their
            customers. AgVend’s white-labeled system of action streamlines
            workflows from field to office, enabling frontline teams to offer
            more efficient and differentiated customer interactions.
            <br />
            <br />
            Since launching their first platform in 2020, AgVend’s technology is
            used by more than 25% of the North American ag retail market.
            Through their growing network of retailers and integrations with
            third-party partners, AgVend is laying the foundation for a
            digitally connected agricultural supply chain. Headquartered in
            Austin, TX, AgVend operates across all major North American
            agricultural regions.
          </p>
        </div>
      </div>
    </>
  );
};

export default AgVendLandingPage;
